import React, { useState } from 'react';
import { get } from 'lodash';
import FormFlag from 'src/components/molecules/form-flag/form-flag.component';
import { IRequestFormMethods } from 'src/models/request.model';
import { ATMSegment } from 'shared-it-appmod-ui';

type IProps = IRequestFormMethods & {
  label: string;
  name: string;
};

const FormFlagField: React.FC<IProps> = (props) => {
  const { control, name, children } = props;

  const [flag, setFlag] = useState<boolean | undefined>(
    get(control, `defaultValuesRef.current.${name}`)
  );

  return (
    <>
      <FormFlag {...props} onChange={setFlag} />
      {flag && <ATMSegment>{children}</ATMSegment>}
    </>
  );
};

export default FormFlagField;
